export const msgYouHaveNoNotifications = "You Have No Notifications At This Time Thank You";
export const msgNoNotifications = "No Notifications";
export const role_required = "Please select user role type";
export const enterFullName = "Please enter a full name.";
export const validFullName = "Please enter a valid full name";
export const enterFirstName = "Please enter a first name";
export const enterLastName = "Please enter a last name";
export const validFirstName = "First name must be at least 3 characters long.";
export const validLastName = "Last name must be at least 3 characters long.";
export const validEmailText = "Please enter a valid email.";
export const validMobileNumberText = "Please enter a valid mobile number";
export const validEmail_OR_MobileNumberText = "Please enter a valid email or mobile number.";
export const validPassword = "Please enter a password";
export const validConfirmPassword = "Please enter a confirm password";
export const enterMessage = "Please enter a message";
export const validMessage = "Please enter a valid message";
export const validMessageLengthText = "Message must be atleast 8 characters long";
export const passwordLengthText = "Please enter valid password between 8-20 characters and must contain atleast one special character, one capital letter, one small letter and one number.";
export const confirmPasswordLengthText = "Confirm Password must be atleast 8 characters long";
export const passwordNotMatchText = "Password and confirm password not matched";
export const validCurrentPasswordText = "Current password is required.";
export const validConfirmationCode = "Please enter a valid confirmation code";
export const acceptTermsCondition = "Please accept terms and conditions";
export const validCompanyName = "Please select a valid company name.";
export const enterCompanyName = "Please enter a valid company name.";
export const validTotalWorkExp = "Please enter a total work experience";
export const validWorkEmailText = "Please enter a valid work email";
export const validWorkMobileNumberText = "Please enter a valid work mobile number.";
export const validWorkEmail_OR_MobileNumberText = "Please enter a valid work email or mobile number.";
export const validWorkAddress = "Please select a work address";
export const expertiseName = "Please enter a expertise name.";
export const expertiseCompetency = "Please select a expertise competency.";
export const workExperience = "Please enter work experience.";
export const enterProductDescription = "Please enter a product description";
export const enterProblemDescription = "Please enter a problem description.";
export const validProName = "Please enter a professional name.";
export const validRepairSuggession = "Please enter a repair suggession";
export const validToolsSupplies = "Please enter a tools & Supplies needed for repair.";
export const validEstimatedCost = "Please enter a estimated cost of repair";
export const validProblemDescription = "Please enter a problem description.";
export const pleaseUploadDoc = "Please upload your documents here";
export const errEmptyEmailOrPhone = "An email or mobile number is required.";
export const errEmptyPassword = "Password is required.";
export const validNewPassword = "New password is required.";
export const errorEmptyEmail = "An email is required.";
export const errorEmptyMobileNumber = "An mobile number is required.";

